const configuration = [
  {
    path: "weChat",
    name: "weChat",
    meta: {
      title: "微信配置"
    },
    component: () => import("../../views/configuration/weChat.vue")
  },
  {
    path: "wxConfigIndex",
    name: "wxConfigIndex",
    meta: {
      title: "公众号配置"
    },
    component: () => import("../../views/configuration/wxconfig.vue")
  },
  {
    path: "wxMenu",
    name: "wxMenu",
    meta: {
      title: "自定义菜单"
    },
    component: () => import("../../views/configuration/wxMenu.vue")
  },
  // 2.11改动，配置信息改成公众号，小程序区分管理
  {
    path: "subScription",
    name: "subScription",
    meta: {
      title: "公众号管理"
    },
    redirect: "/configuration/subScription/home",
    component: () => import("../../views/configuration/subScription.vue"),
    children: [
      {
        path: "home",
        name: "home",
        meta: {
          title: "首页"
        },
        component: () =>
          import("@/views/configuration/subScriptionManage/home.vue")
      },
      {
        path: "config",
        name: "config",
        meta: {
          title: "配置信息"
        },
        component: () => import("@/views/configuration/weChat.vue")
      },
      {
        path: "menu",
        name: "menu",
        meta: {
          title: "自定义菜单"
        },
        component: () => import("@/views/configuration/wxMenu.vue")
      },
      {
        path: "empower",
        name: "empower",
        meta: {
          title: "授权"
        },
        component: () =>
          import("@/views/configuration/subScriptionManage/empower.vue")
      }
    ]
  },
  {
    path: "miniApp",
    name: "miniApp",
    meta: {
      title: "小程序管理"
    },
    redirect: "/configuration/miniApp/index",
    component: () => import("../../views/configuration/miniApp/miniApp.vue"),
    children: [
      {
        path: "index",
        name: "index",
        meta: {
          title: "微信小程序"
        },
        component: () =>
          import("@/views/configuration/miniApp/index.vue")
      },
      {
        path: "aliconfig",
        name: "aliconfig",
        meta: {
          title: "支付宝小程序"
        },
        component: () => import("@/views/configuration/miniApp/aliconfig.vue")
      }
    ]
  }
];

export default configuration;
